import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const NewIndex = lazy(() => import('./new/Index'))
const ManageIndex = lazy(() => import('./:id/Index'))

export const CommunicationsCampaignsRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--communications--campaigns']}>
    <Route index element={<Index />} />
    <Route path='new' element={<NewIndex />} />
    <Route path=':id/*' element={<ManageIndex />} />
  </SubRouter>
))
